import { CodeListItem } from 'app/area/codetable/list/types-store';
import { compactModeThreshold } from 'app/area/risk-matrix-administration/constants';
import { ComplexValue } from 'app/types-shared';
import React from 'react';
import { InfoTextProps, LabelConfig, SliderRating } from 'ui';
import styles from './third-axis-item-picker.scss';

interface ThirdAxisItemPickerProps {
  options: CodeListItem[];
  setThirdAxisItem: (thirdAxisItem: ComplexValue<number>) => void;
  thirdAxisItem: ComplexValue<number>;
  label?: LabelConfig;
  info?: InfoTextProps;
}

export const ThirdAxisItemPicker = ({ options, thirdAxisItem, setThirdAxisItem, label, info }: ThirdAxisItemPickerProps) =>
  options?.length > 0
    ? <div className={`col-md-12 col-lg-7 ${styles.thirdAxisContainer}`}>
      <SliderRating
        className={undefined}
        compactModeTreshold={compactModeThreshold}
        componentId="third_axis_item_picker"
        innerStyle={undefined}
        onChange={setThirdAxisItem}
        options={options.map(item => ({ ...item, value: item.id })) || []}
        sortOptionsDirection={'asc'}
        useOptionsColors={true}
        valueItem={thirdAxisItem}
        categoryOptions={undefined}
        label={label}
        info={info}
      />
    </div>
    : null;
